import { connect } from 'react-redux'

import { sendTilbakemelding, setTakkTilbakemelding, setVisTilbakemeldingmodal } from '../../actions'
import { selectTakkTilbakemelding, selectVisTilbakemeldingmodal } from '../midtdel/midtdelSelector'
import TilbakemeldingModal from '../uukomponenter/TilbakemeldingModal'

import Footer from './Footer'

const sendTilbakemeldingDispatch = (dispatch) => ({
    sendTilbakemelding: (tekst) => {
        dispatch(sendTilbakemelding(tekst))
    },
    setTakkTilbakemelding: (vis) => {
        dispatch(setTakkTilbakemelding(vis))
    },
    setVisTilbakemeldingmodal: (vis) => {
        dispatch(setVisTilbakemeldingmodal(vis))
    }
})

const mapStateToProps = (state) => ({
    takkTilbakemelding: selectTakkTilbakemelding(state),
    visTilbakemeldingmodal: selectVisTilbakemeldingmodal(state)
})

export const Tilbakemelding = connect(mapStateToProps, sendTilbakemeldingDispatch)(TilbakemeldingModal)

export const Fot = connect(mapStateToProps, sendTilbakemeldingDispatch)(Footer)
